import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';

export const UserContext = createContext();

let user = {};

export class UserProvider extends Component {
  constructor(props) {
    super(props);
    this.state = { currentUser: props.currentUser };
  }

  render() {
    const { currentUser } = this.state;
    const { children } = this.props;
    return (
      <UserContext.Provider value={currentUser}>
        {children}
      </UserContext.Provider>
    );
  }
}

UserProvider.defaultProps = {
  /** Additional content to be displayed on the far right inline with the heading. */
  children: PropTypes.node,
};
UserProvider.propTypes = {
  /** Additional content to be displayed on the far right inline with the heading. */
  children: PropTypes.node,
  currentUser: PropTypes.objectOf(PropTypes.any).isRequired,
};

export const getUserData = () => user;
export const setUserData = data => { user = data; };
